import type { FaireProductEntity } from "../../entity_types/product";

export const p_jj925ex72s: FaireProductEntity = {
  token: "p_jj925ex72s",
  type: "product",
  name: "Take Me out to the Ballgame Crop Sweatshirt",
  brandToken: "b_ztfezrm7u7",
  brandName: "Poppy & Pine",
  imageUrl:
    "https://cdn.faire.com/fastly/483fa56e23680c25697cee433cee222e3041f32837cb3235816579d7833a1965.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af948c30c35d88f4338885cd8b25bdf62faf6d5d3bb2919563735e4a152fa691.png",
  ],
  priceDollars: 29,
  description:
    "Buy me some peanuts and crackerjacks! \n\n*puff ink on a 50% cotton 50% polyester sweatshirt\n",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:00.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
